import baseRequest from "../_core/baseRequest";

export default {
    getAppConfig: params => baseRequest.get(`/appconfig/`),
    updateAppConfig: params => baseRequest.put(`/appconfig/${params.appConfigId}`, params),
    createAppConfig: params => baseRequest.post("/appconfig", params)
};
